module.exports = __webpack_public_path__ + "static/media/quarter.af2fb468.png";